import AnimatedError from './AnimatedError';

export default AnimatedError;
